import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { HERO_IMAGE, BRAND, waLink } from "@/data/site";
import { HOME } from "@/constants/testIds";

const Hero = () => {
  return (
    <section className="relative h-[100svh] w-full overflow-hidden">
      {/* Background with Ken Burns */}
      <div className="absolute inset-0 z-0 animate-ken-burns">
        <img
          src={HERO_IMAGE}
          alt="Lenslopers Fotografie hero"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70 z-10" />

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col justify-end pb-24 md:pb-32">
        <div className="container-x">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="eyebrow text-gold mb-6"
          >
            {BRAND.fullName}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, delay: 0.4 }}
            className="font-serif text-white text-4xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight max-w-5xl"
          >
            FOTOGRAFIE
            <span className="italic font-light text-white/70"> &amp; </span>
            <span className="text-gold">FEESTBELEVING</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.7 }}
            className="mt-8 text-white/85 text-sm md:text-base tracking-[0.28em] uppercase font-light"
          >
            <Link to="/huwelijk" className="hover:text-gold transition-colors">Huwelijk</Link>
            <span className="text-gold mx-3">•</span>
            <Link to="/gezin" className="hover:text-gold transition-colors">Gezin</Link>
            <span className="text-gold mx-3">•</span>
            <Link to="/events" className="hover:text-gold transition-colors">Events</Link>
            <span className="text-gold mx-3">•</span>
            <Link to="/huisdieren" className="hover:text-gold transition-colors">Honden</Link>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.95 }}
            className="mt-10 flex flex-wrap gap-4"
          >
            <Link
              to="/portfolio"
              data-testid={HOME.heroCtaPortfolio}
              className="btn-outline-light"
            >
              Bekijk Portfolio
            </Link>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid={HOME.heroCtaBook}
              className="btn-gold"
            >
              Boek een Shoot
            </a>
            <Link
              to="/cadeaubonnen"
              data-testid="hero-cta-gift"
              className="btn-outline-light inline-flex items-center gap-2"
            >
              <Gift size={14} />
              Cadeaubon
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 hidden md:flex flex-col items-center gap-2 text-white/60">
        <span className="text-[10px] uppercase tracking-[0.4em]">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-gold to-transparent" />
      </div>
    </section>
  );
};

export default Hero;
